import * as React from 'react';
import { Builder } from '@builder.io/react';
import image from '@/assets/images/cms/verticalSpacer.svg?inline';

export interface VerticalSpacerComponentProps<TSize> {
	readonly desktopSize: TSize;
	readonly tabletSize?: TSize;
	readonly mobileSize?: TSize;
}

export interface SizeOption {
	readonly label: string;
	readonly value: string;
}

const register = <
	TProps extends VerticalSpacerComponentProps<TSizes[number]['value']>,
	TSizes extends readonly SizeOption[],
>(
	Component: React.FC<TProps>,
	options: {
		readonly sizes: TSizes;
		readonly defaultDesktopSize?: TSizes[number]['value'];
		readonly defaultTabletSize?: TSizes[number]['value'];
		readonly defaultMobileSize?: TSizes[number]['value'];
	},
): void => {
	Builder.registerComponent(Component, {
		name: 'VerticalSpacer',
		image,
		noWrap: true,
		inputs: [
			{
				name: 'desktopSize',
				type: 'string',
				required: true,
				enum: Array.from(options.sizes),
				defaultValue: options.defaultDesktopSize,
			},
			{
				name: 'tabletSize',
				type: 'string',
				enum: Array.from(options.sizes),
				helperText: 'Optional size for tablet breakpoint. If unset, will use desktop size.',
				defaultValue: options.defaultTabletSize,
			},
			{
				name: 'mobileSize',
				type: 'string',
				enum: Array.from(options.sizes),
				helperText:
					'Optional size for mobile breakpoint. If unset, will use tablet size, or desktop size if tablet size is unset.',
				defaultValue: options.defaultMobileSize,
			},
		],
	});
};

export default register;
